import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Lightweight FAQ accordion — one item open at a time, keyboard accessible.
 */
export default function FAQ({ items, testId = "faq" }) {
  const [open, setOpen] = useState(-1);
  return (
    <div className="divide-y divide-[color:var(--border)] border-y border-[color:var(--border)]" data-testid={testId}>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={item.q} data-testid={`${testId}-item-${i}`}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-start justify-between text-left py-5 gap-6 group"
              aria-expanded={isOpen}
              data-testid={`${testId}-q-${i}`}
            >
              <span className="font-display text-lg md:text-xl text-[color:var(--primary-dark)] group-hover:text-[color:var(--accent-teal)] transition-colors">
                {item.q}
              </span>
              <ChevronDown
                size={22}
                className={`shrink-0 mt-1 transition-transform ${isOpen ? "rotate-180 text-[color:var(--accent-mint)]" : "text-[color:var(--muted)]"}`}
              />
            </button>
            {isOpen && (
              <div
                className="pb-6 pr-10 text-[color:var(--muted)] leading-relaxed text-[15px]"
                data-testid={`${testId}-a-${i}`}
              >
                {item.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
